import { RootState } from 'types';
import { uniqBy } from 'lodash';
import { approvedAdapter, imageAlbumAdapter, siteUserStatusAdapter } from './slice';

export const imageSelectors = imageAlbumAdapter.getSelectors(
  (state: RootState) => state.siteDetail.images
);
export const siteUserStatusAdapterSelectors = siteUserStatusAdapter.getSelectors(
  (state: RootState) => state.siteDetail.SiteUserStatus.data
);

export const siteDetailSelector = (state: RootState) => state.siteDetail;
export const siteTabSelector = (state: RootState) =>
  uniqBy(state.siteDetail.SiteCooperatorListToday.data?.cooperators, 'cooperator_id').map(
    (item) => ({
      header: item.cooperator_company_name,
      title: '',
      key: item.cooperator_id,
      // 2025/02/25 FJ 3月分反映分 NO32 start
      code: item.cooperator_code,
      // 2025/02/25 FJ 3月分反映分 NO32 end
    })
  );
export const siteDetailSelectors = approvedAdapter.getSelectors(
  (state: RootState) => state.siteDetail.approved
);
